import React from 'react';
import Image from 'next/image';

const SupplyChainChangingFast = () => {
    return (
        <div className="section-py bg-primary_one relative">
            <div className="bg-supplychain-changing">
                <Image
                    src="/img/supply-chain-changing.svg"
                    className="img-fluid"
                    alt="supply-chain-changing"
                    title="supply-chain-changing"
                    height={385}
                    width={1380}
                    loading="lazy"
                />
            </div>
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-9">
                    <div className="lg:col-span-10 gap-4 grid">
                        <p className="mb-0 text-blue font-bold">Build once. Optimize endlessly.</p>
                        <h2 className="text-white mb-0">
                            The Supply Chain Is Changing Fast<br></br> — And the Numbers Prove It
                        </h2>
                        <p className="text-white opacity-[0.8] mb-0">
                            Modern supply chains are under pressure to move faster, smarter, and with zero margin for error.
                            Here&apos;s why investing in supply chain software development isn&apos;t optional, it&apos;s
                            essential.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 grid-cols-2">
                    <div className="">
                        <Image
                            src="/img/icons/trillion.svg"
                            className="img-fluid mb-2"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            height={50}
                            width={50}
                        />
                        <p className="text-white mb-2 font-bold">$1.94 Trillion</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Projected global logistics spend by 2028, driven by the rise of digital transformation and AI
                            adoption.
                        </p>
                    </div>
                    <div className="">
                        <Image
                            src="/img/icons/chain-leaders.svg"
                            className="img-fluid mb-2"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            height={50}
                            width={50}
                        />
                        <p className="text-white mb-2 font-bold">79% of supply chain leaders</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Plan to invest in AI and predictive analytics to drive real-time decision-making and automation.
                        </p>
                    </div>
                    <div className="">
                        <Image
                            src="/img/icons/chain-organizations.svg"
                            className="img-fluid mb-2"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            height={50}
                            width={50}
                        />
                        <p className="text-white mb-2 font-bold">70% of organizations</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Say they lack end-to-end visibility across their supply chain, leading to delays, inefficiencies, and
                            lost revenue.
                        </p>
                    </div>
                    <div className="">
                        <Image
                            src="/img/icons/faster-order.svg"
                            className="img-fluid mb-2"
                            alt="supply-chain-changing"
                            title="supply-chain-changing"
                            height={50}
                            width={50}
                        />
                        <p className="text-white mb-2 font-bold">52% faster order fulfillment</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Is achieved by businesses that implement smart warehouse and inventory automation tools.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SupplyChainChangingFast;
